/**
 * @description 问卷调查
 * @interface route:/front/doc/survey?questionId=22
*/
import React, { useState, useEffect, useMemo } from 'react';
import { Form, Toast} from "antd-mobile";
import moment from 'moment';
import { Header, ModalAlert } from 'components';
import Library from "library";
import QuestionItem from '../component/questionItem';
import Service from '../service';
import { libData } from './config';
import './index.scss';

export default (props) => {
    // 获取参数
    const { questionId } = Library.Util.url.paramsToObj();

    const [form] = Form.useForm()

    const [dataSource, setDataSource] = useState({})

    useEffect(()=>{
        window.JsBridge.addKeyboardEvent();
        libData.questionId = questionId
        loadData()
        // setDataSource(libData)
    },[])

    const loadData = async ()=> {
        const res = await Service.getQuestionInfo({questionId: libData.questionId},true)
        window.JsBridge.print(res)
        let source = {}
        if(res) {
            const result = res.data
            source = {...result}
            //请求数据处理
            if(result && result.stemVOList) {
                let _list = source.stemVOList.map((item,index)=>{
                const _answers = item.resultList || []
                if(item.questionType === 2) {
                    if(item.optionList && item.optionList.length > 1) {
                        item.optionList = item.optionList.map((item,idx)=>{
                            const matchAnswer = _answers.find(answer => answer.id === item.id || answer.optionNo === item.optionNo)
                            if(matchAnswer) {
                                item.content = matchAnswer.content
                            }
                            return item
                        })
                        //这个reduce暂未用到
                        item.answer = _answers.reduce((pre,current)=> {
                            if(current.answer) {
                                pre.push(current.answer)
                            }
                            return pre
                        },[])
                    }else {
                        item.answer = _answers?.[0]?.content
                    }
                }else if(item.questionType === 3) {
                    item.answer = _answers?.[0]?.content
                }
                else if(item.questionType === 0) {
                    //单选
                    const answer = _answers?.[0]
                    if(answer !== undefined && answer?.content) {
                        const answerObjc = {}
                        answerObjc.value = answer.optionNo
                        answerObjc.content =  answer.content
                        item.answer = answerObjc
                    }else {
                        item.answer = answer?.optionNo
                    }
                    
                }else if(item.questionType === 1) {
                    //多选
                    item.answer = _answers.map(item=>item.optionNo != undefined ? item.optionNo: undefined)
                    const option = item.optionList.find(op => op.optionType ===  1)
                    if(option) {
                        option.content = _answers.find(answer => answer.content)?.content
                    }
                }else if([4,5].includes(item.questionType)) {
                    const answer = _answers?.[0]
                    item.answer = answer?.content
                }
                
                return item
               })
               window.JsBridge.print(_list)
               source.stemVOList = _list
            }
            //设置数据
            setDataSource(source)
        }
        
    }

    const controllerState = useMemo(()=>{
        const ojbt = {
            btnTitle: '提交',
            enable: false
        }
        if(!dataSource.currentTime) return ojbt;
        
        if(moment(dataSource.currentTime).diff(moment(dataSource.questionnaireInfo.questionEndTime),'s') > 0) {
            ojbt.btnTitle = '已结束'
        }else if(dataSource.questionnaireInfo?.questionBeginTime && moment(dataSource.questionnaireInfo.questionBeginTime).diff(moment(dataSource.currentTime),'s') > 0){
            ojbt.btnTitle = '未开始'
        }else {
            if(dataSource.filledFlag === 1) {
                ojbt.btnTitle = '已填写'
            }else {
                ojbt.enable = true
            }
        }
        return ojbt
    },[dataSource])

    const showRule = () => {
        ModalAlert.show({
            title: '活动规则',
            content: <div style={{lineHeight: '18px'}} dangerouslySetInnerHTML={{__html: dataSource.questionnaireInfo.rule}}></div>,
            actions: [{ key: 'cancel', text: '知道了'}],
            onAction: ()=> {
                ModalAlert.hide()
            }
        })
    }

    const validateFields = async ()=> {
        let reslut = {};
        try {
            reslut = await form.validateFields()
        } catch (error) {
            reslut = error
        }
        return reslut;
    }
    const onCommitAction = async () => {
        const reslut = await validateFields()
        console.log(reslut)
        if(reslut.errorFields) {
            return Toast.show(reslut.errorFields[0].errors[0])
        }
        const values = form.getFieldsValue()
        //一个答案为一条数据
        let list = [];
        dataSource.stemVOList.forEach((item,index) => {
            const newItem = {
                stemNo: item.stemNo, 
                questionType: item.questionType,
            }
            
            const value = values[`question${index}`]
            if(Array.isArray(value)) {
               const _list = value.map(v => {
                    if(typeof v == 'object') {
                        //多个输入框的
                        newItem.content = v.content
                        newItem.optionNo = v.optionNo
                    }else {
                        newItem.optionNo = v
                        //多选+有输入的
                        newItem.content = values[`content-${index}-${v}`]
                    }
                    return {...newItem}
                })
                list = list.concat(_list)
            }else {
                if([2, 3].includes(item.questionType)) {
                    newItem.content = value
                }else if([4, 5].includes(item.questionType)) {
                    newItem.content = moment(value).format(item.questionType === 5 ? 'YYYY-MM-DD HH:mm:ss':'YYYY-MM-DD')
                }else {
                    newItem.optionNo = value
                    //单选+有输入的
                    newItem.content = values[`content-${index}-${value}`]
                }
                
                list.push({...newItem})
            }
            
        });

        const param = {
            questionId: libData.questionId,
            resultList: list
        }
        console.log(param)
        ModalAlert.show({
            title: '确认提交',
            content: '提交后结果将不可更改，确认提交当前选项吗？',
            onAction: async (item, index) => {
                ModalAlert.hide()
                if (item.key === 'confirm') {
                    const res = await Service.saveCommitInfo(param, true);
                    if(res) {
                        // Toast.show('感谢您的参与,已收到投票!');
                        window.JsBridge.runAction('alert', 'error', ['感谢您的参与,已收到投票!']);
                        let timer = setTimeout(() => {
                            clearTimeout(timer);
                            window.JsBridge.back();
                        }, 2000);
                    }
                    
                }
            },
            actions: [
                { key: 'cancel', text: '取消' },
                { key: 'confirm', text: '确认提交' }
            ]
        })
    }

    return (
        <div className="questionnaire_page">
            <Header midText={dataSource.questionnaireInfo?.questionName || '问卷调查'} bgColor={'#fff'} />
            <div className='page_body'>
                {
                    dataSource.questionnaireInfo &&
                    <>
                        <div className="top-info">
                            {
                                dataSource.questionnaireInfo.questionEndTime ?
                                <div>
                                    <img src={require('images/icon_endtime.png')}/>
                                    <span>截止时间：</span>
                                    <span>{ moment(dataSource.questionnaireInfo.questionEndTime).format('M月D日') }</span>
                                </div>
                                :<div></div>
                            }
                            
                            <div onClick={showRule} >
                                <img src={require('images/icon_rule.png')}/>
                                <span>{'活动规则 >'}</span>
                            </div>
                        </div>
                    </>
                }
                <div className='form-box'>
                    <Form requiredMarkStyle='none' form={form} disabled={!controllerState.enable}>
                        {
                            dataSource.stemVOList &&
                            dataSource.stemVOList.map((item, i)=> {
                                item.index = i
                                const res = item.optionList?.some(option=> option.optionImg && option.optionType == 2)
                                if(res) {
                                    item.type = 'img'
                                }
                                return <QuestionItem key={i} item={item} form={form}/>
                            })
                        }
                    </Form>
                </div>
            </div>
            <div className='placeholder-area'>
                <div className="bottom-fixed">
                    <div className={`commit-btn ${controllerState.enable ? 'enable':''}`} 
                        onClick={()=>{ 
                            controllerState.enable && onCommitAction()
                        }}>
                        <span>{controllerState.btnTitle}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}